import React from 'react';
import DynamicTable from '@atlaskit/dynamic-table';
import type { Issue } from '../../../services/issues/index.tsx';
import { useTableHead, useTableRows } from './utils.tsx';

const ROWS_PER_PAGE = 7;

type Props = {
	issues: 'loading' | Issue[];
};

const IssueTable = ({ issues }: Props) => {
	const head = useTableHead();
	const rows = useTableRows(issues === 'loading' ? [] : issues);
	return (
		<DynamicTable
			rowsPerPage={
				// Only show the pagination buttons if there is more than one page of issues
				issues !== 'loading' && issues.length > ROWS_PER_PAGE ? ROWS_PER_PAGE : undefined
			}
			isLoading={issues === 'loading'}
			isFixedSize
			head={head}
			rows={rows}
		/>
	);
};

export default IssueTable;
